import * as React from 'react'

export type RootRoute = {
  customTablesIndex: () => string
  customTablesNew: (schemaId: string) => string
  customTablesEdit: (schemaId: string, valueId: string) => string
  customTablesDelete: (schemaId: string, valueId: string) => string
}

export const RouteContext = React.createContext<RootRoute | null | undefined>(null)
